const PROVIDERLESS_PUBLIC_PAGES = ['/login', '/signup', '/passkey'];
const ANONYMOUS_CONTEXT_PAGES = ['/controller_health', '/system-status'];
const USER_FETCH_OPTIONAL_PAGES = ['/system-status'];

function matchesPage(pathName: string | null, page: string): boolean {
  return pathName === page || Boolean(pathName?.startsWith(`${page}/`));
}

/** Pages that render outside UserContext because none of their UI requires it. */
export function isProviderlessPublicPath(pathName: string | null): boolean {
  return PROVIDERLESS_PUBLIC_PAGES.some(page => matchesPage(pathName, page));
}

/** Public pages whose shared navigation still expects an anonymous context. */
export function allowsAnonymousContext(pathName: string | null): boolean {
  return ANONYMOUS_CONTEXT_PAGES.some(page => matchesPage(pathName, page));
}

export function shouldFetchCurrentUser(pathName: string | null): boolean {
  return !isProviderlessPublicPath(pathName)
    && !USER_FETCH_OPTIONAL_PAGES.some(page => matchesPage(pathName, page));
}
